/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { LastRechtGruppeEntryMeta } from './lastRechtGruppeEntryMeta';
import { HistInfoMeta } from './histInfoMeta';
import { RechteIdMeta } from './rechteIdMeta';
import { StandardRechtBeteiligungMasterDetailEntryMeta } from './standardRechtBeteiligungMasterDetailEntryMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { StandardrechtMasterIdMeta } from './standardrechtMasterIdMeta';
import { RechtMasterListEntryMeta } from './rechtMasterListEntryMeta';
import { StandardrechtVersionDetailEntryMeta } from './standardrechtVersionDetailEntryMeta';


export interface StandardrechtMasterDetailEntryMeta { 
    servitutenregisterNr?: string;
    mServitutenregisterNr?: FieldMetaData;
    lastRechtGruppen?: Array<LastRechtGruppeEntryMeta>;
    mLastRechtGruppen?: FieldMetaData;
    rechtArt?: StandardrechtMasterDetailEntryMeta.RechtArtEnum;
    mRechtArt?: FieldMetaData;
    perimeter?: Array<GrundstueckListEntryMeta>;
    mPerimeter?: FieldMetaData;
    id: StandardrechtMasterIdMeta;
    mId?: FieldMetaData;
    rechteId: RechteIdMeta;
    mRechteId?: FieldMetaData;
    ereid?: string;
    mEreid?: FieldMetaData;
    versions?: Array<StandardrechtVersionDetailEntryMeta>;
    mVersions?: FieldMetaData;
    bereinigungsMarkierung?: boolean;
    mBereinigungsMarkierung?: FieldMetaData;
    dokulinkVerfuegbar?: StandardrechtMasterDetailEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    ursprung?: RechtMasterListEntryMeta;
    mUrsprung?: FieldMetaData;
    beteiligungMasters?: Array<StandardRechtBeteiligungMasterDetailEntryMeta>;
    mBeteiligungMasters?: FieldMetaData;
    isNavigierbar?: boolean;
    mIsNavigierbar?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    isSdrDienstbarkeit?: boolean;
    mIsSdrDienstbarkeit?: FieldMetaData;
    bereinigungsGrund?: string;
    mBereinigungsGrund?: FieldMetaData;
}
export namespace StandardrechtMasterDetailEntryMeta {
    export type RechtArtEnum = 'DIENSTBARKEIT' | 'VORMERKUNG' | 'ANMERKUNG' | 'GRUNDLAST' | 'PFANDRECHT' | 'SDR_DIENSTBARKEIT' | 'EIGENTUM_ANTEIL';
    export const RechtArtEnum = {
        DIENSTBARKEIT: 'DIENSTBARKEIT' as RechtArtEnum,
        VORMERKUNG: 'VORMERKUNG' as RechtArtEnum,
        ANMERKUNG: 'ANMERKUNG' as RechtArtEnum,
        GRUNDLAST: 'GRUNDLAST' as RechtArtEnum,
        PFANDRECHT: 'PFANDRECHT' as RechtArtEnum,
        SDR_DIENSTBARKEIT: 'SDR_DIENSTBARKEIT' as RechtArtEnum,
        EIGENTUM_ANTEIL: 'EIGENTUM_ANTEIL' as RechtArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


